<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-title>Input</v-card-title>
          <ValidationObserver ref="form" v-slot="{ invalid }" immediate>
            <v-form v-model="valid">
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-btn
                      text
                      color="primary"
                      href="sample_files/select_samples_for_ec_predict.fasta"
                    >
                      Input file sample
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="Input fasta file"
                      rules="required"
                    >
                      <v-file-input
                        label="Input fasta file"
                        v-model="fastaFile"
                        :error-messages="errors"
                        :success="valid">
                      </v-file-input>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions class="d-flex justify-end">
                <v-btn @click="upload" :disabled="invalid">Submit</v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import axios from 'axios';
import router from "../router";

let instance = null;

export default {
  data: () => ({
    valid: true,
    fastaFile: null,
    tableHeaders: [
      { text: 'name', value: 'name'},
      { text: 'EC_1d_label', value: 'EC_1d_label'},
      { text: 'EC_1d_score', value: 'EC_1d_score'},
      { text: 'EC_4d_label', value: 'EC_4d_label'},
      { text: 'EC_4d_score', value: 'EC_4d_score'},
    ],
    results: [],
    zipUrl: '',
    btnDisabled: true,
  }),
  mounted: function() {
    this.checkLoggedIn();
  },
  methods: {
    ...mapActions("util", ["showProgress", "hideProgress", "openSnackbar", "closeSnackbar", ]),
    // ログインチェック
    checkLoggedIn: function() {
      this.$session.start();
      if (this.$session.has("token")) {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        instance = axios.create({
          headers: {
            Authorization: "JWT " + this.$session.get('token'),
          }
        })
      } else {
        router.push("/login");
      }
    },
    // ファイルアップロード
    upload: function() {
      this.showProgress();

      this.btnDisabled = true;

      const formData = new FormData();
      formData.append('user', this.$store.state.userName);
      formData.append('fastaFile', this.fastaFile);

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        }
      }

      const url = '/api/upload_ec/';
      instance.post(url, formData, config).then((response) => {
        if (response.status === 200) {
          this.hideProgress();
          this.btnDisabled = false;
          this.openSnackbar({ text:'File was uploaded. Please check the result on Result Inquiry screen.', color:'success' });
        } else {
          this.hideProgress();
          this.openSnackbar({ text:'File upload failed.', color:'error' });
        }
      }).catch(() => {
        this.hideProgress();
        this.openSnackbar({ text:'File upload failed.', color:'error' });
      });
    },
  }
};
</script>
